export default "__VITE_ASSET__CpUdfa2w__"